import React from 'react';
import styled from 'styled-components';
import { FaCar, FaWrench, FaOilCan, FaCog, FaSprayCan, FaShieldAlt } from 'react-icons/fa'; 

const AboutContainer = styled.section`
  padding: 80px 0;
  background: #f9f9f9;
  overflow: hidden; 
`;

const AboutWrapper = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: grid;
  /* Em telas grandes, o layout tem duas colunas */
  grid-template-columns: 1fr 1fr;
  align-items: center;
  gap: 30px;
  
  @media screen and (max-width: 768px) {
    /* Em telas pequenas, vira uma coluna só */
    grid-template-columns: 1fr;
  }
`;

const TextWrapper = styled.div`
  @media screen and (max-width: 768px) {
    /* Centralizamos o texto quando ele for o único elemento na tela */
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;

const TopLine = styled.p`
  color: #c77408;
  font-size: 16px;
  line-height: 16px;
  font-weight: 700;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  margin-bottom: 16px;
`;

const Heading = styled.h2`
  margin-bottom: 24px;
  font-size: 48px;
  line-height: 1.1;
  color: #4F4C4C;

  @media screen and (max-width: 480px) {
    font-size: 32px;
  }
`;

const Subtitle = styled.p`
  max-width: 540px;
  margin-bottom: 35px;
  font-size: 18px;
  line-height: 24px;
  color: #4F4C4C;
`;

const IconCloudContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 2rem;
  padding: 2rem;
  position: relative;
  
  @media screen and (max-width: 768px) {
    /* A mágica acontece aqui: o container de ícones some em telas pequenas */
    display: none; 
  }
`;

const CloudIcon = styled.div`
  color: #c77408;
  font-size: 4rem; 
  transition: transform 0.3s ease;

  &:hover {
    transform: scale(1.2);
  }

  &:nth-child(1) {
    font-size: 8rem;
    width: 100%;
    text-align: center;
  }

  &:nth-child(2), &:nth-child(5) {
    font-size: 5rem;
  }
`;


const About = () => {
  return (
    <AboutContainer id="about">
      <AboutWrapper>
        <TextWrapper>
          <TopLine>Nossa História</TopLine>
          <Heading>Confiança que passa de geração para geração.</Heading>
          <Subtitle>
            Bem-vindo à Primeira Linha! Somos uma oficina familiar que há mais de uma década se dedica a cuidar de veículos com a máxima excelência.
            Fundada por Valdeci, nossa paixão por carros e nosso compromisso com a qualidade são os motores que nos movem.
            Aqui, seu carro é tratado com o mesmo carinho e atenção que você tem por ele. Localizados perto do Estádio Serra Dourada, estamos prontos para ser seu parceiro de confiança na estrada.
          </Subtitle>
        </TextWrapper>
        
        {/* Este container inteiro será escondido em telas pequenas */}
        <IconCloudContainer>
          <CloudIcon><FaCar /></CloudIcon>
          <CloudIcon><FaWrench /></CloudIcon>
          <CloudIcon><FaOilCan /></CloudIcon>
          <CloudIcon><FaCog /></CloudIcon>
          <CloudIcon><FaSprayCan /></CloudIcon>
          <CloudIcon><FaShieldAlt /></CloudIcon>
        </IconCloudContainer>

      </AboutWrapper>
    </AboutContainer>
  )
}

export default About;